const common = {
  Common: {
    Search: 'جستجو',
    Details: 'جزيیات',
    Customer: 'مشتری',
    Type: 'نوع',
    Save: 'ذخیره',
    Upload: 'آپلود',
    ChangeStatus: 'تغییر وضغیت',
    NotFoundData: 'موردی جهت نمایش وجود ندارد',
    Close: 'بستن',
    NoData: 'موردی جهت نمایش وجود ندارد.',
    Active: 'فعال',
    CreatedAt: 'تاریخ ایجاد',
    DeActive: 'غیرفعال',
    Expired: 'منقضی شده',
    Used: 'استفاده شده',
    NewPassword: 'رمز جدید',
    ConfirmPassword: 'تایید رمز',
    Input: 'واریز',
    Output: 'برداشت',
    Reason: 'دلیل',
    Excel: 'خروجی اکسل',
    Edit: 'ویرایش',
    CustomerName: 'نام مشتری',
    SellManagement: 'مدیر فروش',
    Description: 'توضیحات',
    BuyManagement: 'مسئول خرید',
    BuyDate: 'تامین شده در',
    name: 'نام',
    more: 'بیشتر',
    showDetails: 'مشاهده جزئیات پروژه',
    mobileNumber: 'شماره همراه',
    copy: 'کپی',
    AccountExpire: 'تاریخ انقضا اکانت',
    DiscountOutput: 'برداشت (تخفیف)',
    CustomerInfo: 'اطلاعات مشتری',
    FinancialInfo: 'اطلاعات مالی',
    ShortagesInfo: 'کمبود های اعلام شده',
    providedShopList: 'لیست خرید هایی که تامین شده است.',
    ContractInfo: 'اطلاعات قرارداد',
    MeterInfo: 'اطلاعات ابعاد بردار',
    InstallerInfo: 'اطلاعات نصاب',
    ProjectFiles: 'فایل های پروژه',
    Status: {
      Label: 'وضعیت',
      Active: 'فعال',
      DeActive: 'غیرفعال',
      Block: 'بلاک شده',
      Default: 'پیش فرض',
      Normal: 'عادی',
    },
    Role: {
      Label: 'نقش',
      Developer: 'برنامه نویس',
      Admin: 'مدیر',
      TopAdmin: 'مدیر با دسترسی بالا',
    },
    Sort: {
      Label: 'مرتب سازی',
      Desc: 'نزولی',
      Asc: 'صعودی',
      Newest: 'جدیدترین',
      Oldest: 'قدیمی ترین',
    },
    Error: {
      Required: 'وارد کردن فیلد الزامی است.',
      EmailValidator: 'لطفا یک ایمیل معتبر وارد کنید.',
      PasswordValidator: 'کلمه عبور باید شامل حروف کوچک و بزرگ، کاراکتر خاص و حداقل طول 8 کاراکتر باشد',
      DontPersonInput: 'لطفا کیبورد خود را به انگلیسی تغییر دهید.',
      ContractNumber: 'فرمت باید شبیه نمونه باشد.xxx-zz-xxx',
      IntegerValidator: 'فیلد باید عددی باشد.',
      RegexValidator: ' فیلد نامعتبر است',
      DiscountPercentValidator: 'درصد وارد شده اشتباه است',
      DiscountAmountValidator: 'قیمت وارد شده اشتباه است',
      ConfirmPasswordValidator: 'رمز ها مطابقت ندارند',
      SimplePasswordValidator: 'کلمه عبور باید شامل  حداقل طول 8 کاراکتر باشد',
      SelectOne: 'لطفا یک مورد را انتخاب کنید',
      MobileNumberLength: 'ارقام شماره همراه باید 11 کارکتر باشد.',
    },
    New: 'جدید',
    Add: 'افزودن',
    WaitingForAnswer: 'در انتظار پاسخ',
    Answerd: 'پاسخ داده شده',
    Answer: 'پاسخ دادن  ',
    EnterYourResponse: 'پاسخ خود را وارد کنید',
    Curency: 'ریال',
    Closed: 'بسته شده',
    SeeAttachedFile: 'مشاهده فایل پیوست',
    Title: 'عنوان',
    IsCommon: 'متداول',
    AddPattern: 'افزودن الگو',
    Pattern: ' الگو',
    Hour: 'ساعت',
    Confirm: 'تایید',
    Reject: 'رد',
    Back: 'بازگشت',
    ConfirmData: 'تایید اطلاعات',
    Alert: {
      Success: 'تغییرات با موفقیت انجام شد',
      Delete: 'با موفقیت حذف شد',
      Insert: 'ذخیره با موفقیت انجام شد',
    },
    Application: 'برنامه',
    Ios: 'اپل',
    Android: 'اندروید',
    Game: 'بازی',
    Loading: 'در حال دریافت اطلاعات ... لطفا منتظر باشید.',
    AccountType: {
      Real: 'حقیقی',
      Legal: 'حقوقی',
    },
    Person: 'نفر',
    Count: 'تعداد',
    Date: 'تاریخ',
    Order: {
      label: 'جهت نمایش',
      vertical: 'عمودی',
      horizontal: 'افقی',
    },
    Yes: 'بلی',
    No: 'خیر',
    History: 'تاریخچه',
    Days: {
      Saturday: 'شنبه',
      Sunday: 'یکشنبه',
      Monday: 'دوشنبه',
      Tuesday: 'سه‌شنبه',
      Wednesday: 'چهارشنبه',
      Thursday: 'پنج‌شنبه',
      Friday: 'جمعه',
    },
    Expire: 'انقضا',
    Number: 'عدد',
  },
}

export default common
